jQuery(document).ready(function ($) {
  if ($('body').hasClass('page-template-ocrolus')) {
    const chart2025Q1DebtInflow = document.getElementById('2025-q1-debtinflow');

    new Chart(chart2025Q1DebtInflow, {
      type: 'bar',
      data: {
        labels: ['Q1 2024', 'Q2 2024', 'Q3 2024', 'Q4 2024', 'Q1 2025',],
        datasets: [
          {
            label: 'Non-bank',
            data: [8534, 7848, 8211, 8253, 8596],
            borderColor: '#0064dd',
            backgroundColor: '#0064dd',
            fill: false,
          },
          {
            label: 'Bank',
            data: [8390, 8216, 8439, 6187, 5529],
            borderColor: '#83dcc1',
            backgroundColor: '#83dcc1',
            fill: false,
          },
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += '$' + context.parsed.y;
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
            title: {
              display: true,
              text: 'Quarter / Year',
              padding: 20,
            },
          },
          y: {
            title: {
              display: true,
              text: 'Median Monthly Debt Inflow',
            },
            border: { display: false },
            ticks: {
              stepSize: 1000,
              callback: function (value, index, ticks) {
                return '$' + Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]);
              },
              padding: 20,
            },
            min: 0,
            max: 9000,
          }
        }
      }
    });

    const chart2025Q1FutureGrowth = document.getElementById('2025-q1-futuregrowth');

    new Chart(chart2025Q1FutureGrowth, {
      type: 'bar',
      data: {
        labels: ['Q1 2024', 'Q2 2024', 'Q3 2024', 'Q4 2024', 'Q1 2025'],
        datasets: [
          {
            label: 'Significant Growth',
            data: [31, 30, 27, 30, 30],
            backgroundColor: '#0064dd',
            borderColor: '#0064dd',
          },
          {
            label: 'Moderate Growth',
            data: [62, 62, 65, 65, 63],
            backgroundColor: '#000082',
            borderColor: '#000082',
          },
          {
            label: 'No Growth',
            data: [7, 9, 8, 6, 7],
            backgroundColor: '#83dcc1',
            borderColor: '#83dcc1',
          },
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            border: { display: false },
            ticks: {
              stepSize: 10,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            max: 70,
          }
        }
      }
    });
  }
});
